import { httpClient } from '@/utils/httpClient';
import { API_CONFIG } from '@/config/api';

export interface CifStampData {
  stampBase64: string | null;
  isDefault: boolean;
  filename: string | null;
}

const endpoint = (): string => `${API_CONFIG.ACTIONS_API_BASE_PATH}/cif-stamp`;

export const cifStampService = {
  async get(): Promise<CifStampData> {
    return httpClient.get<CifStampData>(endpoint());
  },

  async upload(stampBase64: string, filename: string): Promise<void> {
    await httpClient.put<void>(endpoint(), {
      stampBase64,
      filename,
    });
  },

  async remove(): Promise<void> {
    await httpClient.delete<void>(endpoint());
  },
};
